import { useNavigate } from "react-router";
import logoIISS from "../assets/iiss-logo.png";
import Button from "../components/Button";
import { useTranslation } from "../i18n/TranslationProvider";

function Landing() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="custom-container mx-auto w-4/5 lg:w-1/2">
            <div className="flex flex-col gap-6 md:flex-row items-center">
                <img src={logoIISS} className="md:-mt-6 w-48 md:w-64 h-auto" />
                <div className="md:pt-6 -mt-4">
                    <h4 className="text-lg md:text-2xl text-center mx-auto">
                        {t("landing.welcome")}
                    </h4>
                    {/* NOTE: acronym breakdown kept English-only on purpose —
                        the bolded letters (I-I-S-S) are tied to the English
                        words. Translating this sentence breaks the visual
                        letter match. Flag to Lynne if this needs a
                        language-specific treatment instead. */}
                    <p className="text-center mx-auto mb-2">
                        (The <b>I</b>njury <b>I</b>mpact <b>S</b>everity{" "}
                        <b>S</b>core) <br />
                    </p>
                    <p className="text-center mx-auto italic">
                        {t("landing.tagline")}
                    </p>
                </div>
            </div>
        
            <p className="text-center my-4 md:my-6">
                <p>
                    {t("landing.descriptionPart1")}{" "}
                    <span className="font-bold italic"> {t("landing.descriptionShould")} </span>
                    {t("landing.descriptionPart2")}{" "}
                    <a
                        href="https://nsuworks.nova.edu/neurosports/vol1/iss2/19/"
                        className="text-teal-600"
                    >
                        {t("landing.descriptionPeerReviewed")}
                    </a>{" "}
                    {t("landing.descriptionPart3")}
                </p>
            </p>
            <div className="my-6 flex flex-col md:flex-row gap-6">
                <div className="flex-1">
                    <h4 className="text-lg mb-2 text-center font-semibold">
                        {t("landing.sportsHeading")}
                    </h4>
                    <div className="aspect-video w-full">
                        <iframe
                            className="w-full h-full rounded"
                            src="https://www.youtube.com/embed/-uKhw_ShlKs"
                            title={t("landing.videoTitleSports")}
                            allowFullScreen
                            loading="lazy"
                            referrerpolicy="strict-origin-when-cross-origin"
                        />
                    </div>
                </div>
               
                

             <div className="flex-1">
                    <h4 className="text-lg mb-2 text-center font-semibold">
                        {t("landing.emrHeading")}
                    </h4>
                    <div className="aspect-video w-full">
                        <iframe
                            className="w-full h-full rounded"
                            src="https://www.youtube.com/embed/TynaaAh5v-Y"
                            title={t("landing.videoTitleEmr")}
                            allowFullScreen
                            loading="lazy"
                            referrerpolicy="strict-origin-when-cross-origin"
                        />
                    </div>
                    
                    {/* <div className="mt-4 px-2 flex justify-between items-center">
                        <p>Already have an account?</p>
                        <a 
                            href="https://test-iiss-emr.powerofpatients.com"
                            className="text-teal-600 cursor-pointer"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <h6>Login</h6>
                        </a>
                    </div> */}
                    {/* <div className="mt-2 px-2 flex justify-between items-center">
                        <p>Don't have an account?</p>
                        <a 
                            href="https://test-iiss-emr.powerofpatients.com/register"
                            className="text-teal-600 cursor-pointer"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <h6>Register</h6>
                        </a>
                    </div> */}
                </div> 
                

            
            </div>
            {/* Login / Register section */}

            <hr className="my-6 border border-gray-200 w-full p-0 mx-auto" />

           <h4 className="text-base md:text-xl text-center mx-auto">
                {t("landing.readyToStart")}
            </h4>

            <div className="mt-4 px-2 text-center">
                <h6
                    className="inline-block text-teal-600 cursor-pointer text-lg bg-teal-50 hover:bg-teal-100 py-3 px-6 rounded-md transition duration-150 ease-in-out"
                    onClick={() => navigate("/login")}
                >
                    {t("landing.login")}
                </h6>
            </div>
            <div className="mt-2 px-2 flex items-center justify-center space-x-1">
                <p>{t("landing.noAccount")}</p>
                <h6
                    className="text-teal-600 cursor-pointer "
                    onClick={() => navigate("/register")}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            navigate("/register");
                        }
                    }}
                    >
                    {t("landing.register")}
                </h6>
            </div>

            <div className="mt-2 px-2 flex items-center justify-center space-x-1">
                <p>{t("landing.needHelp")}</p>
                <h6
                    className="text-teal-600 cursor-pointer"
                    onClick={() => navigate("/help")}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            navigate("/help");
                        }
                    }}
                    >
                    {t("landing.contactUs")}
                </h6>
            </div>

                
            <hr className="mt-6 border border-gray-200 w-full p-0 mx-auto" />
            
            
        </div>
    );
}

export default Landing;